export default "__VITE_ASSET__DB41vk4u__"